import React from 'react';
import PropTypes from 'prop-types';
import truncate from 'lodash/truncate';

import {
	// eslint-disable-next-line no-unused-vars
	PhotoBoxWrapper, ContentWrapper, UserWrapper, WrappedUser, Img, Video,
} from './components';
import {
	animateFullScreen, animateToBackground, bindRotateAnimation, bindUserRotateAnimation,
	animateToGrid, toggleAnimations, prepareAnimations,
} from '../animatedVisualizations/animations';
import options from '../animatedVisualizations/options';

class UgcBox extends React.Component {
	static defaultProps = {
		duration: options.animationDuration,
		fullscreenScale: options.fullscreenUgcScale,
		userNameDefaultVisibility: 'invisible',
	};

	static propTypes = {
		url: PropTypes.string.isRequired,
		user: PropTypes.string.isRequired,
		// Props are used in animations
		// eslint-disable-next-line react/no-unused-prop-types
		messageCount: PropTypes.number,
		// eslint-disable-next-line react/no-unused-prop-types
		fullscreenScale: PropTypes.number,
		// eslint-disable-next-line react/no-unused-prop-types
		userNameDefaultVisibility: PropTypes.string,
		// eslint-disable-next-line react/no-unused-prop-types
		duration: PropTypes.number,
	};

	constructor(props) {
		super(props);
		this.messageContainer = React.createRef();
		this.contentContainer = React.createRef();
		this.wrapperContainer = React.createRef();
		this.userContainer = React.createRef();
		this.name = React.createRef();
		this.videoElement = React.createRef();
		this.decoration = React.createRef();

		this.animateFullScreen = animateFullScreen.bind(this);
		this.animateToBackground = animateToBackground.bind(this);
		this.animateToGrid = animateToGrid.bind(this);

		this.bindRotateAnimation = bindRotateAnimation.bind(this);
		this.bindUserRotateAnimation = bindUserRotateAnimation.bind(this);

		this.toggleAnimations = toggleAnimations.bind(this);
		this.prepareAnimations = prepareAnimations.bind(this);

		this.controller = new AbortController();

		this.state = {
			preloaded: false,
		};
	}

	componentDidMount() {
		const { type, url } = this.props;
		if (type === 'video') {
			this.preloadVideo(url);
		} else {
			this.preloadImage(url);
		}
	}

	componentDidUpdate(prevProps) {
		try {
			this.toggleAnimations(prevProps).then(() => {
				if (
					this.videoElement.current &&
					this.props.fullscreen === true &&
					this.videoElement.current.paused
				) {
					this.playVideo();
				} else if (
					this.videoElement.current &&
					this.props.fullscreen === false
				) {
					this.stopVideo();
				}
			});
		} catch (e) {
			console.error(e);
		}
	}

	componentWillUnmount() {
		this.controller.abort();
	}

	setLoaded = () => {
		if (this.state.preloaded) {
			return;
		}
		this.setState(() => ({ preloaded: true }), () => {
			this.prepareAnimations();
		});
	};

	getPreviewUrl = () => {
		const { type, url } = this.props;
		let previewUrl = url;
		// Change preview by first frame of video
		if (type === 'video') {
			const base = url.substring(0, url.lastIndexOf('.'));
			previewUrl = `${base}/preview-00001.png`;
		}

		return previewUrl;
	};

	playVideo = () => {
		try {
			if (this.videoElement.current.src) {
				this.videoElement.current.play();
			}
		} catch (e) {
			console.error(e);
		}
	};

	preloadVideo = () => {
		const { url } = this.props;
		return fetch(url, { signal: this.controller.signal })
			.then(response => response.blob())
			.then((blob) => {
				if (this.videoElement.current) {
					this.setState({
						videoSource: URL.createObjectURL(blob),
					});
				}
			});
	};

	stopVideo = () => {
		if (this.videoElement.current.src) {
			this.videoElement.current.pause();
			this.videoElement.current.currentTime = 0;
		}
	};

	preloadImage(url) {
		const img = new Image();
		img.onload = this.setLoaded;
		img.src = url;
	}

	calculateRightPosition = () => {
		if (this.name && this.name.current && this.contentContainer) {
			const aside = this.name.current.offsetWidth / 2;
			const scaledWidth = this.contentContainer.current.offsetWidth * options.fullscreenUgcScale;
			const availableSpace = (window.document.body.offsetWidth - scaledWidth) / 2;

			if ((aside * options.fullscreenUgcScale) > availableSpace) {
				const safeAside = (availableSpace / options.fullscreenUgcScale) - 10;
				return -(
					Math.max(0, safeAside)
				);
			}

			return -aside;
		}

		return 0;
	};

	renderContent = () => {
		const {
			user = '', fullscreen, idx, type,
		} = this.props;
		const caption = truncate(user, { length: 17, separator: ' ', omission: '' });

		if (type === 'video') {
			return (
				<PhotoBoxWrapper ref={this.messageContainer} fullscreen={fullscreen} idx={idx}>
					<div ref={this.wrapperContainer}>
						<ContentWrapper ref={this.contentContainer}>
							<Video
								onCanPlayThrough={this.setLoaded}
								ref={this.videoElement}
								autoplay={(fullscreen === true)}
								muted={false}
								loop
								src={this.state.videoSource}
							/>
							{/* <PlayIcon ref={this.decoration} /> */}
							<UserWrapper ref={this.userContainer} style={{ right: this.calculateRightPosition() }}>
								<WrappedUser ref={this.name} style={{ fontSize: 25 }}><p>{caption}</p></WrappedUser>
							</UserWrapper>
						</ContentWrapper>
					</div>
				</PhotoBoxWrapper>
			);
		}

		return (
			<PhotoBoxWrapper ref={this.messageContainer} fullscreen={fullscreen} idx={idx}>
				<div ref={this.wrapperContainer}>
					<ContentWrapper ref={this.contentContainer}>
						<Img src={this.getPreviewUrl()} />
						<UserWrapper ref={this.userContainer} style={{ right: this.calculateRightPosition() }}>
							<WrappedUser ref={this.name} style={{ fontSize: 25 }}><p>{caption}</p></WrappedUser>
						</UserWrapper>
					</ContentWrapper>
				</div>
			</PhotoBoxWrapper>
		);
	};

	render() {
		return (
			<React.Fragment>
				{this.renderContent()}
			</React.Fragment>
		);
	}
}

export default UgcBox;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/ugcvisualization/UgcBox.component.js